import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

import { Odom } from '../../HomePage/components/Highlights';

const ELearningHighlights = () => (

  <Container fluid>
    <Row>
      <Col xs={6} md={4}>
        <Row style={{ height: '100%', paddingRight: 10, paddingLeft: 10 }}>
          <NewCourses />
        </Row>
      </Col>
      <Col xs={6} md={4}>
        <Row style={{ height: '100%', paddingRight: 10, paddingLeft: 10 }}>
          <Brokers />
        </Row>
      </Col>
      <Col xs={12} md={4}>
        <Row style={{ height: '100%', paddingRight: 10, paddingLeft: 10 }}>
          <Webinars />
        </Row>
      </Col>
    </Row>
  </Container>
)

const Webinars = () => (
  <Col style={{ backgroundColor: '#F3F5ED', marginTop: 20, padding: 20 }}>
    <Row style={{
      height: '100%'
      // display: 'flex', flexDirection: 'row', justifyContent: 'center'
    }}>
      <Col xs={4} style={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', padding: 0 }}>
        <Odom
          number={40}
          text="+"
          style={{ justifyContent: 'center', alignItems: 'center', height: '100%' }}
          textStyle={{
            marginTop: 20,
            fontSize: 32,
            fontFamily: 'montserrat bold',
            fontWeight: 'bold',
            color: '#1B526D',
          }}
          odomStyle={{
            fontSize: 32,
            fontFamily: 'montserrat bold',
            fontWeight: 'bold',
            color: '#1B526D',
            // padding: 0,
          }} />
      </Col>
      <Col xs={8} style={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', padding: 0, paddingTop: 20 }}>
        <p style={{
          fontSize: 18,
          fontFamily: 'montserrat medium',
          // fontWeight: 'bold',
          color: '#4D788D',
          padding: 0,
          // paddingLeft: 20,
          // paddingRight: 20,
          lineHeight: 1.2,
          // textAlign: 'center'
        }}>
          <span style={{
            fontSize: 18,
            fontFamily: 'montserrat bold',
            fontWeight: 'bold',
            color: '#14183A',
            padding: 0,
          }}>webinars</span> on key industry topics
      </p>
      </Col>
    </Row>
  </Col>
)

const Brokers = () => (
  <Col style={{ marginTop: 20, padding: 20 }}>
    <Row style={{
      // display: 'flex', flexDirection: 'row', justifyContent: 'center'
    }}>
      <Odom number={4000}
        // style={{ justifyContent: 'flex-start', paddingLeft: 20 }}
        format="(,ddd)"
        odomStyle={{
          fontSize: 28,
          fontFamily: 'montserrat bold',
          fontWeight: 'bold',
          color: '#1B526D',
          lineHeight: 1,
          padding: 0,
        }} />
    </Row>
    <Row>
      <Col>
        <p style={{
          fontSize: 18,
          fontFamily: 'montserrat medium',
          // fontWeight: 'bold',
          color: '#4D788D',
          padding: 0,
          paddingLeft: 20,
          paddingRight: 20,
          lineHeight: 1.2,
          textAlign: 'center'
        }}>
          <span style={{
            fontSize: 18,
            fontFamily: 'montserrat bold',
            fontWeight: 'bold',
            color: '#14183A',
            padding: 0,
          }}>brokers</span> took part in eLearning
      </p>
      </Col>
    </Row>
  </Col>
)

const NewCourses = () => (
  <Col style={{ backgroundColor: '#F3F5ED', marginTop: 20, padding: 20 }}>
    <Row style={{
      // display: 'flex', flexDirection: 'row', justifyContent: 'center'
    }}>
      <Odom number={12}
        // style={{ justifyContent: 'flex-start', paddingLeft: 20 }}
        odomStyle={{
          fontSize: 28,
          fontFamily: 'montserrat bold',
          fontWeight: 'bold',
          color: '#1B526D',
          lineHeight: 1,
          padding: 0,
        }} />
    </Row>
    <Row>
      <Col>
        <p style={{
          fontSize: 18,
          fontFamily: 'montserrat medium',
          // fontWeight: 'bold',
          color: '#4D788D',
          padding: 0,
          paddingLeft: 20,
          paddingRight: 20,
          lineHeight: 1.2,
          textAlign: 'center'
        }}>
          <span style={{
            fontSize: 18,
            fontFamily: 'montserrat bold',
            fontWeight: 'bold',
            color: '#14183A',
            padding: 0,
          }}>new courses</span> in the eLearning program
      </p>
      </Col>
    </Row>
  </Col>
)

export default ELearningHighlights;
